module.exports = __webpack_public_path__ + "static/img/react.672291e3.png";